<template>
    <div>
        <compFormEdit class="margin-15 clearfix" ref="editform" :formdata="getBase" v-model="formData" :labelWidth="90" :col="1" />
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{$t('erp.virtualstore.generatetemplate',{defaultValue:'生成组合模板'})}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
        </div>
    </div>
</template>
<script>
// import { HttpSaveProgram } from '@/service/boss/allot';
import { mapGetters } from "vuex";


export default {
    data(){
        return {
            formData:{}
        }
    },
    computed:{
        ...mapGetters('diction',['getNewAccountList','getNewWarehouseCodeList']),
        amazonaccount(){
            return this.getNewAccountList.filter(item=>{
                return item.attach.type == 'amazon'
            })
        },
        oneandfiveWarehouse(){
            return this.getNewWarehouseCodeList.filter(item=>{
                return item.attach.warehouseType == '1' || item.attach.warehouseType == '5'
            })
        },
        getBase(){
            return [
                {
					label: this.$t('fbb.inbound.choose',{defaultValue:'选择'})+this.$t('bi.work.task_account_id',{defaultValue:'渠道'}),
                    key: "channel",
                    tag: "vSelect",
                    options: this.amazonaccount,
                    props: {
                        filterable: true,
                        multiple:true
                    }
                },
                {
                    label: this.$t('fbb.inbound.choose',{defaultValue:'选择'})+this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
                    tag: "vSelect",
                    key: "warehouse",
                    options:this.oneandfiveWarehouse,
                    props:{
                        filterable: true,
                        multiple:true
                    }
                }
            ]
        }
    },
    methods:{
        submit(){
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS+"/api/v2/AmazonTemplate/group/warehouse",{...this.formData},'download');
        },
        cancel(){
            this.$emit('on-close')
        }
    },
    
}
</script>